import React, {Component} from 'react';
import {toastr} from 'react-redux-toastr';
import {connect} from 'react-redux';
import { clone } from '../../../../../shared/services/lodashInJS.js';
import {Link} from 'react-router-dom';

import conf from '../../../../conf.js';
import api from '../../../../../api.js';
import AlertOffersForm from '../../../../components/Forms/Alert/AlertOffersForm.jsx';
import SubmitButton from '../../../../components/Forms/Alert/SubmitButton.jsx';
import Loader from '../../../../../shared/components/Loader/Loader.jsx';
import {generate} from '../../../../routes.js';
import FreelancePage from "../../../../../shared/components/Styled/Containers/FreelancePage.jsx";

class AlertOffers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      form: {
        id: null,
        name: 'alert-offers-' + this.props.user.id,
        channel: this.expandChannels(),
        frequency: conf.alert.frequency.weekly.value,
        cities: [],
        subUniverses: this.expandSubUniverses(),
      },
      emailSelected: true,
      smsSelected: true,
      citiesSelected: false,
      loading: true,
      submitting: false,
    };

    this.loadData(this.props.user);
  }

  /**
   *
   * @param {Array} selectedSubUniverses
   * @returns {Array}
   */
  expandSubUniverses = (selectedSubUniverses = []) => {
    const availableSubUniverses = this.props?.currentUniverse.sub_universes?.length ? this.props.currentUniverse.sub_universes : [];

    return availableSubUniverses.reduce((acc, subUniverse) => {
      acc.push({
        id: subUniverse.id,
        text: subUniverse.name,
        value: selectedSubUniverses.includes(subUniverse.id)
      });

      return acc;
    }, []);
  };

  /**
   * @param {Array} selectedSubUniverses
   * @returns {Array}
   */
  flattenSubUniverses = (selectedSubUniverses) => {
    const availableSubUniverses = (this.props?.currentUniverse.sub_universes?.length ? this.props.currentUniverse.sub_universes : []).map(
      subUniverse => subUniverse.id
    );

    return selectedSubUniverses.reduce((acc, subUniverse) => {
      if (subUniverse.value === true && availableSubUniverses.includes(subUniverse.id)) {
        acc.push(subUniverse.id);
      }

      return acc;
    }, []);
  };

  /**
   *
   * @param {number} selectedChannels
   * @returns {Array}
   */
  expandChannels = (selectedChannels = 0) => {
    const availableChannels = Object.values(conf.alert.channels);

    return availableChannels.reduce((acc, availableChannel) => {
      acc.push({
        text: availableChannel.text,
        value: availableChannel.disabled ? true : !!(selectedChannels & availableChannel.value),
        disabled: !!availableChannel.disabled
      });

      return acc;
    }, [])
  };

  /**
   * @param {Array} selectedChannels
   * @returns {number}
   */
  flattenChannels = (selectedChannels) => {
    const availableChannels = Object.values(conf.alert.channels).reduce((acc, channel) => {
      acc[channel.value] = channel.text;

      return acc;
    }, []);

    return selectedChannels.reduce((acc, channel) => {
      if (channel.value === true && availableChannels.includes(channel.text)) {
        acc += availableChannels.indexOf(channel.text);
      }

      return acc;
    }, 0);
  };

  loadData = async (user) => {
    const alertsOffers = (await api.alertsOffers.getAll({
      user: user.id
    })).data;

    if (alertsOffers.length > 0) {
      const alertOffers = alertsOffers[0];

      this.setState((state, props) => ({
        form: {
          id: alertOffers.id,
          frequency: alertOffers.frequency,
          channel: this.expandChannels(alertOffers.channel),
          suspended_until: alertOffers.suspended_until,
          cities: alertOffers.cities,
          subUniverses: this.expandSubUniverses(alertOffers.sub_universes),
        },
        emailSelected: !!(alertOffers.channel & conf.alert.channels.email.value),
        smsSelected: !!(alertOffers.channel & conf.alert.channels.sms.value),
        citiesSelected: !!alertOffers.cities.length,
      }));
    }

    this.setState({
      loading: false
    })
  };

  handleCitiesSelectedChange = (event) => {
    this.setState({citiesSelected: event.target.checked});
  };

  save = async (data) => {
    this.setState({submitting: true});
    try {
      let alertOffers = clone(data);

      if (this.state.citiesSelected) {
        alertOffers.cities = data.cities.map((item) => item.id);
      } else {
        alertOffers.cities = [];
      }

      const channel = this.flattenChannels(alertOffers.channel);

      const response = (await api.alertsOffers.edit({
        alertOffers: this.state.form.id,
        user: this.props.user.id,
        channel: channel,
        is_actived: channel > 0,
        frequency: alertOffers.frequency,
        suspended_until: channel ? alertOffers.suspended_until : null,
        cities: alertOffers.cities,
        subUniverses: this.flattenSubUniverses(alertOffers.subUniverses),
      })).data;

      if (!response.is_actived) {
        response.frequency = conf.alert.frequency.weekly.value;
      }

      this.setState({
        form: {
          ...this.state.form,
          channel: alertOffers.channel,
          frequency: response.frequency,
          cities: response.cities,
          subUniverses: alertOffers.subUniverses
        },
        citiesSelected: !!response.cities.length,
        emailSelected: !!(response.channel & conf.alert.channels.email.value),
        smsSelected: !!(response.channel & conf.alert.channels.sms.value)
      });

      if (this.props.create) {
        await this.props.submit({
          user: this.props.user
        });
      }
    } catch (e) {
      console.warn(e);
      toastr.error(e.data.message);
    } finally {
      this.setState({submitting: false});
      this.props.onFormSuccess();
    }
  };

  render() {
    if (this.state.loading) {
      return <Loader visible={true} fill={false} contains={true}>Chargement en cours...</Loader>;
    }

    if (this.state.submitting) {
      return <Loader visible={true} fill={false} contains={true}>Sauvegarde en cours...</Loader>;
    }

    return (
      <FreelancePage className="step-upload-cv p-5 p-relative">
        <AlertOffersForm
          initialValues={this.state.form}
          emailSelected={this.state.emailSelected}
          citiesSelected={this.state.citiesSelected}
          handleCitiesSelectedChange={this.handleCitiesSelectedChange}
          enableReinitialize={true}
          onSubmit={this.save}
        />
        {this.props.create &&
        <div className="mt-5 d-flex flex-wrap align-items-center">
          <div className="mr-auto">
            <Link to={generate({name: 'homepage'})} className="gray">
              Je finirai plus tard (ne pas sauvegarder)
            </Link>
          </div>
          <SubmitButton className="btn btn-primary ml-auto">Étape suivante</SubmitButton>
        </div>}
        {this.props.edit &&
        <div className="mt-5 d-flex">
          <SubmitButton className="mx-auto btn btn-primary">Sauvegarder</SubmitButton>
        </div>
        }
      </FreelancePage>
    );
  }
}

export default connect(
  state => ({
    currentUniverse: state.universe.currentUniverse
  })
)(AlertOffers);